import { render, staticRenderFns } from "./lab-exambasis-selector.vue?vue&type=template&id=68fe52d1"
import script from "./lab-exambasis-selector.vue?vue&type=script&lang=js"
export * from "./lab-exambasis-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports